import React from "react";
import PropTypes from "prop-types";
import _groupBy from "lodash/groupBy";
import QuoteCell from "./QuoteCell";
import { OUTCOMES } from "./Expectations";
import styles from "../../styles/components/ExpectationsQuotes.css";
import { B2B_DICT } from "../../modules/drivers";

export function ExpectationOutcomeTitle({ outcome }) {
    return (
        <p
            className={styles.outcomeTitle}
            style={{ borderColor: outcome.color }}
        >
            {outcome.label}
        </p>
    );
}

export function ExpectationOutcomeQuoteList({ quotes }) {
    if (!quotes) {
        return <p className={styles.noDataMessage}>No quotes found.</p>;
    }
    return (
        <ul className={styles.outcomeQuotesList}>
            {quotes.map(quote => {
                const isB2B =
                    quote.DEM_B2B_Age ||
                    quote.DEM_B2B_Revenue ||
                    quote.DEM_B2B_Role ||
                    quote.DEM_B2B_Size;

                return (
                    <li key={quote.id} className={styles.outcomeQuotesItem}>
                        <QuoteCell
                            quoteContent={quote.outcomeQuote}
                            segmentIds={
                                isB2B
                                    ? [
                                          B2B_DICT[quote.DEM_B2B_Age],
                                          B2B_DICT[quote.DEM_B2B_Revenue],
                                          B2B_DICT[quote.DEM_B2B_Role],
                                          B2B_DICT[quote.DEM_B2B_Size]
                                      ]
                                    : quote.segmentIds
                            }
                        />
                    </li>
                );
            })}
        </ul>
    );
}

export default function ExpectationsQuotes({ expectation }) {
    const quotesByOutcome = _groupBy(
        expectation.quotes,
        quote => quote.outcome
    );

    return (
        <div className={styles.quotes}>
            {OUTCOMES.map(outcome => {
                return (
                    <div key={outcome.key} className={styles.outcomeQuotes}>
                        <ExpectationOutcomeTitle outcome={outcome} />
                        <ExpectationOutcomeQuoteList
                            quotes={quotesByOutcome[outcome.key]}
                        />
                    </div>
                );
            })}
        </div>
    );
}

ExpectationsQuotes.propTypes = {
    expectation: PropTypes.shape({
        quotes: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                outcome: PropTypes.string.isRequired,
                outcomeQuote: PropTypes.string.isRequired,
                segmentIds: PropTypes.arrayOf(PropTypes.number).isRequired
            })
        )
    })
};



// WEBPACK FOOTER //
// ./src/components/Results/ExpectationsQuotes.js